export default __webpack_public_path__ + "static/media/co2.ab06c2cc.png";